export default __webpack_public_path__ + "static/media/our_future.a357795d.jpg";